export class ObjectPool<T> {
  private readonly available: T[] = [];

  constructor(
    private readonly factory: () => T,
    private readonly maxRetained = 1024,
  ) {}

  acquire(): T {
    return this.available.pop() ?? this.factory();
  }

  release(value: T): void {
    if (this.available.length < this.maxRetained) this.available.push(value);
  }

  get retained(): number {
    return this.available.length;
  }
}
